import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, ArrowLeft } from 'lucide-react';
import { ErrorState } from '../../components/ui/ErrorState';
import { Button } from '../../components/ui/Button';

/**
 * A URL that does not exist.
 *
 * `path="*"` used to be a bare `<Navigate>` to the dashboard: a typo in the
 * address bar silently dropped the user somewhere else, which looks like the app
 * losing their place rather than the address being wrong.
 */
export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <ErrorState
      icon={Compass}
      title="Esta página no existe"
      description="La dirección que abriste no corresponde a ninguna sección de NinjaHubs."
    >
      <Button variant="primary" icon={ArrowLeft} onClick={() => navigate('/dashboard')}>
        Ir al Dashboard
      </Button>
    </ErrorState>
  );
};
